// extracted by mini-css-extract-plugin
export var active = "_1a-9";
export var backButton = "_1a-8";
export var clone = "_1a-e";
export var collapseBar = "_1a-k";
export var collapseMode = "_1a-m";
export var collapsed = "_1a-o";
export var dimmed = "_1a-i";
export var dragHandle = "_1a-c";
export var dropdownIcon = "_1a-g";
export var expanding = "_1a-n";
export var hidden = "_1a-x";
export var iconContainer = "_1a-q";
export var iconSwapper = "_1a-w";
export var navItem = "_1a-6";
export var navItemIcon = "_1a-f";
export var navProfile = "_1a-7";
export var notificationCountBadge = "_1a-j";
export var notificationDot = "_1a-r";
export var optionsContainer = "_1a-h";
export var primaryNav = "_1a-0";
export var primaryNavDivider = "_1a-v";
export var primaryNavResizeHandle = "_1a-2";
export var primaryNavResizing = "_1a-1";
export var primaryNavTabSection = "_1a-u";
export var primaryTab = "_1a-p";
export var primaryTabIconBox = "_1a-s";
export var secondaryNav = "_1a-3";
export var selected = "_1a-t";
export var settingsNav = "_1a-4";
export var settingsNavItems = "_1a-5";
export var show = "_1a-d";
export var sideNav = "_1a-l";
export var teamItem = "_1a-a";
export var userProfileItem = "_1a-b";